<div class="modal fade" tabindex="-1" [id]="modalId">
	<div class="modal-dialog">
		<div class="modal-content">

			<!-- HEADER -->
			<div class="modal-header text-dark">
				<h5 class="modal-title">
					<i class="bi bi-exclamation-triangle-fill me-2"></i>
					Change password
				</h5>
			</div>

			<!-- BODY -->
			<form [formGroup]="form" class="modal-body">
				<p>
					Your account was recently reset and you were issued a temporary password. Please choose a secure password.
				</p>

				<!-- Password -->
				<div class="form-floating mb-3">
					<input type="password" id="newPassword" class="form-control" placeholder="New Password"
						formControlName="newPassword">
					<label for="newPassword">New Password</label>
					@if (form.get('newPassword')?.touched && form.get('newPassword')?.invalid) {
					<div class="text-danger small">Password is required.</div>
					}
				</div>

				<!-- Confirm Password -->
				<div class="form-floating mb-3">
					<input type="password" id="confirmPassword" class="form-control" placeholder="Confirm Password"
						formControlName="confirmPassword">
					<label for="confirmPassword">Confirm Password</label>
					@if (form.get('confirmPassword')?.touched && form.get('confirmPassword')?.invalid) {
					<div class="text-danger small">Confirm Password is required.</div>
					}
					@if (form.errors?.['passwordMismatch'] && form.get('confirmPassword')?.touched) {
					<div class="text-danger small">Passwords do not match.</div>
					}
				</div>
			</form>

			<!-- FOOTER -->
			<div class="modal-footer">
				<button type="button" class="btn btn-secondary" (click)="signOut()">
					Sign Out
				</button>
				<button type="button" class="btn btn-primary" [disabled]="form.invalid" (click)="save()">
					Save
				</button>
			</div>

		</div>
	</div>
</div>